class CampaignProjectCards extends HTMLElement {
  connectedCallback() {
    if (this.resizeObserver) return
    this.voteListener = (event) => {
      const button = event.target.closest('[data-project-vote]')
      const formId = this.dataset.klaviyoFormId?.trim()
      if (!button || !this.contains(button) || !formId) return
      window._klOnsite = window._klOnsite || []
      window._klOnsite.push(['openForm', formId])
    }
    this.addEventListener('click', this.voteListener)
    const headings = [...this.querySelectorAll('.campaign-project__content h3')]
    const widths = new WeakMap()
    const fitHeadings = () => {
      cancelAnimationFrame(this.frame)
      this.frame = requestAnimationFrame(() => {
        for (const heading of headings) {
          heading.style.removeProperty('--project-title-fit')
          const width = heading.getBoundingClientRect().width
          // Keep words intact when a translation is wider than its column.
          // Ordinary wrapped headings retain the merchant's configured size.
          if (width > 0 && heading.scrollWidth > width + 1) {
            heading.style.setProperty(
              '--project-title-fit',
              String((width - 1) / heading.scrollWidth),
            )
          }
        }
      })
    }
    this.resizeObserver = new ResizeObserver((entries) => {
      let changed = false
      for (const { target, contentRect } of entries) {
        if (widths.get(target) !== contentRect.width) {
          widths.set(target, contentRect.width)
          changed = true
        }
      }
      if (changed) fitHeadings()
    })
    this.textObserver = new MutationObserver(fitHeadings)
    for (const heading of headings) {
      this.resizeObserver.observe(heading)
      this.textObserver.observe(heading, { childList: true, characterData: true, subtree: true })
    }
    this.fontListener = fitHeadings
    document.fonts?.addEventListener('loadingdone', fitHeadings)
    fitHeadings()
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.voteListener)
    cancelAnimationFrame(this.frame)
    this.resizeObserver?.disconnect()
    this.textObserver?.disconnect()
    document.fonts?.removeEventListener('loadingdone', this.fontListener)
    this.resizeObserver = undefined
  }
}

if (!customElements.get('campaign-project-cards')) {
  customElements.define('campaign-project-cards', CampaignProjectCards)
}
